module.exports = __webpack_public_path__ + "img/1554014866.8f95b7c7.jpg";